import React, { useEffect, useState } from 'react';
import { changePassword, logout } from '../services/auth.service';
import Button from './Button';
import Feedback from './Feedback';
import { useAuth } from '../contexts/AuthContext';

const ChangePassword: React.FC = () => {
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState([] as string[]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const { refresh, userInfo } = useAuth();

  const handleSave = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setErrors([]);

    if (newPassword !== confirmPassword) {
      setErrors(['Passwords do not match']);
      return;
    }

    setLoading(true);
    const result = await changePassword(password, newPassword);
    if (result.success) {
      setMessage('Password changed.  Please log in again...');
      await logout();
      window.location.href = '/Account/Login?passwordChanged=true';
    } else {
      setMessage('');
      setErrors(result.errors);
    }
    setLoading(false);
  };

  const getInfo = async () => {
    const info = userInfo;
    setEmailAddress(info?.emailAddress ?? '');
  };

  useEffect(() => {
    getInfo().catch(console.error);
  }, [userInfo]);

  return (
    <form onSubmit={handleSave} className="content-form">
      <h3>Change your password</h3>
      <div className="field">
        <label htmlFor="username" className="control-label form-label">
          Email Address
        </label>
        <input
          disabled
          type="text"
          id="username"
          placeholder="Email Address"
          required
          value={emailAddress}
        />
      </div>
      <div className="field">
        <label htmlFor="password" className="control-label form-label">
          Current Password
        </label>
        <input
          id="password"
          type="password"
          placeholder="Current Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="new-password" className="control-label form-label">
          New Password
        </label>
        <input
          id="new-password"
          type="password"
          placeholder="New Password"
          required
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="confirm-password" className="control-label form-label">
          Confirm Password
        </label>
        <input
          id="confirm-password"
          type="password"
          placeholder="Confirm Password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>

      <div className="button-container">
        <Button className="action-button" isLoading={loading} isSubmit={true}>
          Change Password
        </Button>
      </div>
      <Feedback messages={errors} type="error" />
      <Feedback message={message} type="success" />
    </form>
  );
};

export default ChangePassword;
